module.exports = __webpack_public_path__ + "static/media/Rods.af696015.pdf";